// frontend/src/components/SortableItem.js
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export function SortableItem({ id, children }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
  const style = { transform: CSS.Transform.toString(transform), transition };
  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <div className="flex items-start gap-2">
        <button {...listeners} className="cursor-grab mt-2 px-1 text-[#3A3530] opacity-40 hover:opacity-100" title="Drag to reorder">⠿</button>
        <div className="flex-1">{children}</div>
      </div>
    </div>
  );
}
